const GEO_CACHE_KEY = 'appivorous_lead_geo';
const LANDING_PAGE_KEY = 'appivorous_landing_page';

const readSession = (key) => {
  try { return window.sessionStorage.getItem(key); } catch { return null; }
};

const writeSession = (key, value) => {
  try { window.sessionStorage.setItem(key, value); } catch { /* Storage may be disabled. */ }
};

export async function getLeadContext() {
  const sourceUrl = window.location.href;
  let landingPage = readSession(LANDING_PAGE_KEY);
  if (!landingPage) {
    landingPage = sourceUrl;
    writeSession(LANDING_PAGE_KEY, landingPage);
  }

  let geo = {};
  const cachedGeo = readSession(GEO_CACHE_KEY);
  if (cachedGeo) {
    try { geo = JSON.parse(cachedGeo); } catch { /* Fetch a fresh value below. */ }
  }

  if (!geo.ipAddress) {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 4000);
    try {
      const response = await fetch('https://ipwho.is/?fields=success,ip,country,country_code,region,region_code,city,postal,timezone.id', {
        signal: controller.signal,
      });
      const data = await response.json();
      if (response.ok && data.success !== false) {
        geo = {
          ipAddress: data.ip || 'Unavailable',
          stateRegion: [data.region, data.region_code].filter(Boolean).join(' (') + (data.region && data.region_code ? ')' : ''),
          city: data.city || 'Unavailable',
          postalCode: data.postal || 'Unavailable',
          country: [data.country, data.country_code].filter(Boolean).join(' (') + (data.country && data.country_code ? ')' : ''),
          visitorTimezone: data.timezone?.id || 'Unavailable',
        };
        writeSession(GEO_CACHE_KEY, JSON.stringify(geo));
      }
    } catch {
      geo = { ipAddress: 'Unavailable', stateRegion: 'Unavailable', city: 'Unavailable', country: 'Unavailable' };
    } finally {
      window.clearTimeout(timeout);
    }
  }

  return {
    ...geo,
    sourceUrl,
    sourcePath: window.location.pathname,
    landingPage,
    referrer: document.referrer || 'Direct visit',
    pageTitle: document.title,
  };
}

